import request from '@/utils/request'


// 查询用户签到列表
export function listUserSign(query) {
  return request({
    url: '/user/user/sign/list',
    method: 'get',
    params: query
  })
}

// 查询用户签到分页
export function pageUserSign(query) {
  return request({
    url: '/user/user/sign/page',
    method: 'get',
    params: query
  })
}

// 查询用户签到详细
export function getUserSign(data) {
  return request({
    url: '/user/user/sign/detail',
    method: 'get',
    params: data
  })
}

// 新增用户签到
export function addUserSign(data) {
  return request({
    url: '/user/user/sign/add',
    method: 'post',
    data: data
  })
}

// 修改用户签到
export function updateUserSign(data) {
  return request({
    url: '/user/user/sign/edit',
    method: 'post',
    data: data
  })
}

// 删除用户签到
export function delUserSign(data) {
  return request({
    url: '/user/user/sign/delete',
    method: 'post',
    data: data
  })
}
